export const THEME_COLOR_SCHEME = "teal";
